import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TypedAbstractControl } from '@principle-theorem/ng-shared';

interface IControlDisplay<T> {
  value: T | string | null | undefined;
  isRequired: boolean;
}

@Component({
  selector: 'pr-acc-control-summary',
  imports: [MatIconModule],
  templateUrl: './acc-control-summary.component.html',
  styleUrl: './acc-control-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccControlSummaryComponent {
  control = input.required<TypedAbstractControl<unknown>>();
  label = input.required<string>();
  showLabel = input<boolean>(true);
  compactWarning = input<boolean>(false);
  lookUp = input<Record<string, unknown>>();
  reverseLookUp = input<boolean>(false);
  formatFn = input<(value: unknown) => string>();
  displayMap = input<Record<string, unknown>>();
  display = computed(() => this._displayValue(this.control()));

  private _displayValue<T>(
    control: TypedAbstractControl<T>
  ): IControlDisplay<T> {
    const map = this.lookUp();
    const displayMap = this.displayMap();
    const isReverse = this.reverseLookUp();
    const formatFn = this.formatFn();

    let displayValue = control.value;

    if (map && control.value) {
      displayValue = this._performLookup(
        map,
        control.value,
        isReverse,
        displayMap
      ) as T;
    }

    return {
      value: formatFn && displayValue ? formatFn(displayValue) : displayValue,
      isRequired: control.hasValidator(Validators.required),
    };
  }

  private _performLookup(
    map: Record<string, unknown>,
    value: unknown,
    reverse: boolean,
    displayMap?: Record<string, unknown>
  ): unknown {
    if (reverse) {
      const entry = Object.entries(map).find(
        ([, mapValue]) => mapValue === value
      );
      return entry ? entry[0] : value;
    }

    if (displayMap) {
      const key = map[value as string];
      return displayMap[key as string] || value;
    }

    return map[value as string] || value;
  }
}
